<div class="dashboard-container">

  <!-- Loading global -->
  <div *ngIf="carregando" class="loading-global">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
  </div>

  <ng-container *ngIf="!carregando">

    <!-- Banner de renovacao de plano (plano pago vencido): no topo do dashboard,
         logo abaixo do header global (mesmo padrao do mobile). -->
    <div *ngIf="planoPagoVencido"
         class="banner-renovacao"
         [class.banner-renovacao--expirado]="!dentroDaCarencia"
         role="button"
         tabindex="0"
         (click)="navegarParaPlanos()"
         (keyup.enter)="navegarParaPlanos()">
      <i class="pi pi-exclamation-triangle banner-renovacao__icon" aria-hidden="true"></i>
      <div class="banner-renovacao__texto">
        <span class="banner-renovacao__titulo">{{ bannerRenovacaoTitulo }}</span>
        <span class="banner-renovacao__msg">{{ bannerRenovacaoMensagem }}</span>
      </div>
      <span class="banner-renovacao__acao">{{ bannerRenovacaoAcao }}</span>
      <i class="pi pi-chevron-right banner-renovacao__chevron" aria-hidden="true"></i>
    </div>

    <!-- SECAO 1: Header compacto + KPI Cards -->
    <app-dashboard-header
      [totalReceita]="totalReceita"
      [totalDespesa]="totalDespesa"
      [totalSaldo]="totalSaldo"
[dadosReceitasMensal]="dadosReceitasLinha"
      [dadosDespesasMensal]="dadosDespesasLinha"
      [contas]="contas"
      [contaSelecionada]="contaSelecionada"
      [periodoSelecionado]="periodoSelecionado"
      [currencySymbol]="currencySymbol"
      [currencyDigits]="currencyDigits"
      [currencyLocale]="currencyLocale"
      [permissoes]="permissoes"
      [dataInicio]="periodoSelecionado.dataInicio"
      [dataFim]="periodoSelecionado.dataFim"
      [totalReceitaMesAnterior]="totalReceitaMesAnterior"
      [totalDespesaMesAnterior]="totalDespesaMesAnterior"
      [totalSaldoMesAnterior]="totalSaldoMesAnterior"
      [periodoEhMesFechado]="periodoEhMesFechado"
      (periodoChanged)="onPeriodoAlterado($event)"
      (contaChanged)="onContaAlterada($event)"
      (refreshClicado)="recarregarTudo()">
    </app-dashboard-header>

    <!-- SECAO 1b: Notificacoes do contador (contrato + despesas acessorias
         pendentes). Card autossuficiente: some quando nao ha pendencias.
         Exibido apenas com o privilegio "Gestao do Contador" (espelha o mobile). -->
    <app-dashboard-contador-notificacoes
      *ngIf="permissoes.gestaoContador"></app-dashboard-contador-notificacoes>

    <!-- SECAO 2: Primeiros Passos (condicional, full-width) -->
    <app-dashboard-primeiros-passos
      *ngIf="exibirPrimeirosPassos"
      [temProduto]="temProduto"
      [temCliente]="temCliente"
      [temVenda]="temVenda">
    </app-dashboard-primeiros-passos>

    <!-- SECAO 3: Fatura Eletronica (condicional, full-width) -->
    <app-dashboard-fatura-eletronica
      *ngIf="exibirFaturaEletronica"
      [temDadosEmpresa]="temDadosEmpresa"
      [temCertificadoDigital]="temCertificadoDigital"
      [temTimbradoEletronico]="temTimbradoEletronico"
      [temVendaTimbrado]="temVendaTimbrado"
      (dismiss)="onFaturaEletronicaDismiss()">
    </app-dashboard-fatura-eletronica>

    <!-- SECAO 4a: Avisos (linha exclusiva, full-width) -->
    <app-dashboard-avisos
      *ngIf="exibirAvisos"
      [avisos]="avisos">
    </app-dashboard-avisos>

    <!-- SECAO 4b: Main Grid (Grafico 2/3 + Plano 1/3) -->
    <div [class.main-grid]="permissoes.configuracao"
         [class.main-grid-full]="!permissoes.configuracao"
         *ngIf="(permissoes.receitas || permissoes.gastos) || permissoes.configuracao">
      <!-- Coluna 2/3: Grafico de Linha -->
      <app-dashboard-grafico-linha
        *ngIf="permissoes.receitas || permissoes.gastos"
        [anoSelecionado]="anoGraficoLinha"
        [dadosReceitas]="permissoes.receitas ? dadosReceitasLinha : []"
        [dadosDespesas]="permissoes.gastos ? dadosDespesasLinha : []"
        [loading]="loadingGraficoLinha"
        [currencySymbol]="currencySymbol"
        [currencyDigits]="currencyDigits"
        [currencyLocale]="currencyLocale"
        (anoChanged)="onAnoGraficoAlterado($event)">
      </app-dashboard-grafico-linha>

      <!-- Coluna 1/3: Sidebar (Plano) -->
      <div class="sidebar-stack" *ngIf="permissoes.configuracao">
        <app-dashboard-plano
          [configuracaoEmpresa]="configuracaoEmpresa"
          [totalVendasNoMes]="totalVendasNoMes">
        </app-dashboard-plano>
      </div>
    </div>

    <!-- SECAO 5: Contas a Pagar / Receber (2 colunas) -->
    <div *ngIf="permissoes.conta" class="contas-row">
      <app-dashboard-contas
        tipo="pagar"
        [contas]="contasAPagar"
        [totalAberto]="totalAPagar"
        [totalPago]="totalPagos"
        [loading]="loadingContas"
        [currencySymbol]="currencySymbolPagar"
        [currencyDigits]="currencyDigitsPagar"
        [currencyLocale]="currencyLocalePagar"
        [contas_disponiveis]="contas"
        [contaSelecionadaLocal]="contaSelecionadaPagar"
        [periodoSelecionadoLocal]="periodoSelecionadoPagar"
        (contaLocalChanged)="onContaPagarAlterada($event)"
        (periodoLocalChanged)="onPeriodoPagarAlterado($event)"
        (mostrarMaisClicado)="onMostrarMaisPagar()"
        (contaClicada)="onContaPagarClicada($event)"
        (totalAbertoClicado)="onNavContasPagar('aberto')"
        (totalPagoClicado)="onNavContasPagar('pago')">
      </app-dashboard-contas>

      <app-dashboard-contas
        tipo="receber"
        [contas]="contasAReceber"
        [totalAberto]="totalAReceber"
        [totalPago]="totalRecebidos"
        [loading]="loadingContas"
        [currencySymbol]="currencySymbolReceber"
        [currencyDigits]="currencyDigitsReceber"
        [currencyLocale]="currencyLocaleReceber"
        [contas_disponiveis]="contas"
        [contaSelecionadaLocal]="contaSelecionadaReceber"
        [periodoSelecionadoLocal]="periodoSelecionadoReceber"
        (contaLocalChanged)="onContaReceberAlterada($event)"
        (periodoLocalChanged)="onPeriodoReceberAlterado($event)"
        (mostrarMaisClicado)="onMostrarMaisReceber()"
        (contaClicada)="onContaReceberClicada($event)"
        (totalAbertoClicado)="onNavContasReceber('aberto')"
        (totalPagoClicado)="onNavContasReceber('pago')">
      </app-dashboard-contas>
    </div>

    <!-- SECAO 6: DRE Pizzas (full-width) -->
    <app-dashboard-grafico-pizza
      *ngIf="permissoes.receitas || permissoes.gastos"
      [dadosDespesas]="permissoes.gastos ? dadosDespesasPizza : []"
      [dadosReceitas]="permissoes.receitas ? dadosReceitasPizza : []"
      [totalDespesas]="permissoes.gastos ? totalDespesasPizza : 0"
      [totalReceitas]="permissoes.receitas ? totalReceitasPizza : 0"
      [loading]="loadingPizza"
      [currencySymbol]="currencySymbol"
      [currencyDigits]="currencyDigits"
      [currencyLocale]="currencyLocale"
      [moedaInicial]="configuracaoEmpresa?.moeda?.enum"
      (filtroChanged)="onFiltroPizzaAlterado($event)"
      (itemDespesaClicado)="onDrillDownDespesa($event)"
      (itemReceitaClicado)="onDrillDownReceita($event)">
    </app-dashboard-grafico-pizza>

    <!-- SECAO 7: Bottom Grid (2/3 + 1/3) -->
    <div class="bottom-grid"
         *ngIf="(exibirMinhasContas && permissoes.conta) || exibirEstoque">
      <app-dashboard-minhas-contas
        *ngIf="exibirMinhasContas && permissoes.conta"
        [contas]="contas"
        [loading]="loadingMinhasContas"
        [currencySymbol]="currencySymbol"
        [currencyDigits]="currencyDigits"
        [currencyLocale]="currencyLocale"
        [moedaPadraoEmpresa]="configuracaoEmpresa?.moeda?.enum"
        (contaExcluida)="recarregarContas()"
        (contaCriada)="recarregarContas()">
      </app-dashboard-minhas-contas>

      <app-dashboard-estoque
        *ngIf="exibirEstoque"
        [produtos]="produtosEstoqueLimitado"
        [loading]="loadingEstoque">
      </app-dashboard-estoque>
    </div>

  </ng-container>

</div>

<p-toast></p-toast>
